import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer-container">
      <div className="footer-content">
        
        {/* Left: Support Email */}
        <div className="footer-email">
          <a href="mailto:support@presspeels.com">support@presspeels.com</a>
        </div>
        
        {/* Center: Copyright */}
        <div className="footer-copyright">
          © 2025 Press Peels, LLC. All Rights reserved
        </div>
        
        {/* Right: Spacer to maintain layout balance */}
        <div className="footer-spacer"></div>
      </div>
    </footer>
  );
};

export default Footer; 